import React from "react";

const WhyMonkziSection = () => {
  return (
    <section style={{
      background: "rgba(0, 0, 0, 0.45)",
      color: "#fff",
      padding: "32px 24px",
      borderRadius: "24px",
      marginTop: "40px",
      boxShadow: "0 4px 20px rgba(255,255,255,0.08)",
      border: "1px solid rgba(255,255,255,0.06)"
    }}>
      <h2 style={{ fontSize: "1.8em", color: "#FFD700", marginBottom: "16px", fontWeight: "bold" }}>
        🧘‍♂️ Why MONKZI? Why Now?
      </h2>

      <p style={{ fontSize: "1.08em", lineHeight: "1.7", color: "#e0e0e0" }}>
        MONKZI isn’t just another meme coin — it’s the <strong>start of a movement</strong>.<br /><br />
        We’ve already:
      </p>

      <ul style={{ paddingLeft: "20px", margin: "14px 0", color: "#FFD700", fontSize: "1em" }}>
        <li>✅ 1B token supply, no presale, no whales</li>
        <li>✅ Giveaway #1 complete (1M MONKZI distributed)</li>
        <li>✅ Live DEX price, charts & verified listings</li>
        <li>✅ Honeypot status cleared — fully tradable</li>
      </ul>

      <p style={{ fontSize: "1.08em", marginTop: "20px", lineHeight: "1.7", color: "#e0e0e0" }}>
        <strong>🚀 What’s Coming:</strong>
      </p>

      <ul style={{ paddingLeft: "20px", margin: "14px 0", color: "#FFD700", fontSize: "1em" }}>
        <li>📱 MONKZI Mobile App</li>
        <li>🎮 Meme-themed Game</li>
        <li>🚀 Launchpad for indie projects</li>
        <li>🔥 More giveaways, more burns</li>
      </ul>

      <p style={{ fontSize: "1.1em", fontWeight: "bold", color: "#FFD700", marginTop: "24px" }}>
        🍌 Meditate. Meme. Moon.
      </p>
    </section>
  );
};

export default WhyMonkziSection;
